import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MediaService } from "../../common/media.service";
import { SiteService } from "src/app/new-sites-management/common/services/site.service";

import { take } from "rxjs/operators";
import { HttpHeaders } from "@angular/common/http";
import { AuthService } from "src/app/services/auth.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-list",
  templateUrl: "./list.component.html",
  styleUrls: ["./list.component.css"],
})
export class ListComponent implements OnInit {
  view = "cards";
  type: string;
  cultureId = 0;
  searchText = "";
  user: any;
  requestOptions: { headers: HttpHeaders };
  @Input() fromComponent: boolean;

  @Input() selectedMedia: any;
  @Output() selectedFile = new EventEmitter<any>();
  files: any[] = [];
  constructor(
    public mediaManagerService: MediaService,
    public siteService: SiteService,
     private snotifyService: ToastrService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.mediaManagerService.search.searchText=''
       this.user = this.authService.getLoggedUser();
    let a = this.selectedMedia;
    this.siteService.isSiteChanged$.pipe(take(1)).subscribe((res) => {
      this.requestOptions = {
        headers: new HttpHeaders({
          SiteId: this.user.siteId + "",
          UserId: this.user.id,
        }),
      };
      this.mediaManagerService.getFoldersFirstTime();
    });
    this.siteService.usedSiteCulture$.subscribe((res) => {
      if (res) this.cultureId = res[0].id;
    });
  }

  getSubItems() {
       this.mediaManagerService
      .searchMediaAndFolders(this.mediaManagerService.folder.parentFolderId)
      .subscribe((res: any) => {
        this.mediaManagerService.isParentIdChanged(
          res.currentFolderId,
          res.currentFolderName,
          res.parentFolderId,
          res.itemCount,
          res.currentFolderBreadcrumb

        );
      });
  }

  selectedFiles(data) {
    this.selectedFile.emit(data);
  }

  public onFilesAdded(event) {
    var formData = new FormData();
    formData.append("CultureId", this.cultureId.toString());
    if (this.mediaManagerService.folder.parentId) {
      formData.append(
        "ParentId",
        this.mediaManagerService.folder.parentId.toString()
      );
    }
    for (var i = 0; i < event.addedFiles.length; i++) {
      formData.append("Uploads", event.addedFiles[i]);
    }
    this.mediaManagerService.saveMedia(formData).subscribe(
      (res: any) => {
        this.mediaManagerService
          .searchMediaAndFolders(this.mediaManagerService.folder.parentId)
          .subscribe();
        this.openNotifySuccess(res.status.body);
      },
      (error) => {
        this.openNotifyfaild(error.message);
      }
    );
  }
  public openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  public openNotifyfaild(message: string) {
    this.snotifyService.error("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }
}
